import { Injectable } from '@angular/core';
import { FiBackendService } from '../../shared/fi-backend/fi-backend.service';
import { LoadingService } from '../../shared/fi-loading/loading.service';
import { ITransferOwnershipData } from '@fi-app/other-settings/transfer-ownership/fi-transfer-ownership';
import { ObjectTypes } from '@fi-shared/types';

@Injectable()
export class FiTransferOwnershipService {
    constructor(
        private fiBackend: FiBackendService,
        private fiLoading: LoadingService,
    ) {}

    getTransferOwnershipData() {
        return this.fiLoading.trackPromise(
            this.fiBackend.fetchData<ITransferOwnershipData>('Core/TransferOwnership/GetTransferOwnershipData'),
        );
    }

    getAvailableObjectTypes(fromUserId: number, toUserId: number) {
        return this.fiLoading.trackPromise(
            this.fiBackend.fetchDataPost<ObjectTypes[]>(
                `Core/TransferOwnership/GetAvailableObjectTypesForTransferOwnership`,
                {
                    fromUserId: fromUserId,
                    toUserId: toUserId,
                },
            ),
        );
    }

    getDisabledUserIdsByShareRights(fromUserId: number) {
        return this.fiLoading.trackPromise(
            this.fiBackend.fetchData<number[]>(`Core/TransferOwnership/GetDisabledUserIdsByShareRights/${fromUserId}`),
        );
    }

    transferOwnerShip(fromUserId: number, toUserId: number, objectTypes: ObjectTypes[]) {
        return this.fiLoading.trackPromise(
            this.fiBackend.fetchDataPost<ObjectTypes[]>(`Core/TransferOwnership/TransferOwnership`, {
                fromUserId: fromUserId,
                toUserId: toUserId,
                objectTypes: objectTypes,
            }),
        );
    }
}
